// extracted by mini-css-extract-plugin
export default {"container":"style_container__XwrQR","card":"style_card__oitCX","row":"style_row__7V-Qe","btnsRow":"style_btnsRow__sNY6J"};